import React from 'react'
import Home from '../Components/Home'
import GlobalReach from '../Components/GlobalReach'
import ProductOffering from '../Components/ProductOffering'
import Testimonial from '../Components/Testimonial'
import Assembly from '../Components/Assembly'
import Team from '../Components/Team'
import JoinTeam from '../Components/JoinTeam'
import Gallery from '../Components/Gallery'
import Contact from '../Components/Contact'
import LogoSwiper from '../Components/LogoSwiper'

const DureWebsite = () => {
  return (
    <div>
        <Home/>
        <GlobalReach/>
        <LogoSwiper/>
        <ProductOffering/>
        <Testimonial/>
        <Assembly/>
        <Team/>
        <JoinTeam/>
        <Gallery/>
        <Contact/>
    </div>
  )
}

export default DureWebsite